module.exports = __webpack_public_path__ + "static/img/doc-guide-4.9c6a9eb.png";